export default "__VITE_ASSET__BdFjckEr__"